/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FileMetaDataDto,
  HandleFileUploadBody,
  HandleFileUploadParams,
  MarkFileAsReplacedParams,
  ResponseDataFileMetaDataDto,
  ResponseDataString
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const handleFileUpload = (
    handleFileUploadBody: HandleFileUploadBody,
    params?: HandleFileUploadParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto>(
      {url: `/api/files/upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handleFileUploadBody,
        params, signal
    },
      options);
    }
  


export const getHandleFileUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleFileUpload>>, TError,{data: HandleFileUploadBody;params?: HandleFileUploadParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof handleFileUpload>>, TError,{data: HandleFileUploadBody;params?: HandleFileUploadParams}, TContext> => {

const mutationKey = ['handleFileUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleFileUpload>>, {data: HandleFileUploadBody;params?: HandleFileUploadParams}> = (props) => {
          const {data,params} = props ?? {};

          return  handleFileUpload(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HandleFileUploadMutationResult = NonNullable<Awaited<ReturnType<typeof handleFileUpload>>>
    export type HandleFileUploadMutationBody = HandleFileUploadBody
    export type HandleFileUploadMutationError = unknown

    export const useHandleFileUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleFileUpload>>, TError,{data: HandleFileUploadBody;params?: HandleFileUploadParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handleFileUpload>>,
        TError,
        {data: HandleFileUploadBody;params?: HandleFileUploadParams},
        TContext
      > => {

      const mutationOptions = getHandleFileUploadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const handleFileUpload1 = (
    fileMetaDataDto: FileMetaDataDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResponseDataFileMetaDataDto>(
      {url: `/api/files/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fileMetaDataDto, signal
    },
      options);
    }
  


export const getHandleFileUpload1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleFileUpload1>>, TError,{data: FileMetaDataDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof handleFileUpload1>>, TError,{data: FileMetaDataDto}, TContext> => {

const mutationKey = ['handleFileUpload1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleFileUpload1>>, {data: FileMetaDataDto}> = (props) => {
          const {data} = props ?? {};

          return  handleFileUpload1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HandleFileUpload1MutationResult = NonNullable<Awaited<ReturnType<typeof handleFileUpload1>>>
    export type HandleFileUpload1MutationBody = FileMetaDataDto
    export type HandleFileUpload1MutationError = unknown

    export const useHandleFileUpload1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleFileUpload1>>, TError,{data: FileMetaDataDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handleFileUpload1>>,
        TError,
        {data: FileMetaDataDto},
        TContext
      > => {

      const mutationOptions = getHandleFileUpload1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const markFileAsReplaced = (
    params: MarkFileAsReplacedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResponseDataFileMetaDataDto>(
      {url: `/api/files/mark-replaced`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getMarkFileAsReplacedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFileAsReplaced>>, TError,{params: MarkFileAsReplacedParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markFileAsReplaced>>, TError,{params: MarkFileAsReplacedParams}, TContext> => {

const mutationKey = ['markFileAsReplaced'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markFileAsReplaced>>, {params: MarkFileAsReplacedParams}> = (props) => {
          const {params} = props ?? {};

          return  markFileAsReplaced(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkFileAsReplacedMutationResult = NonNullable<Awaited<ReturnType<typeof markFileAsReplaced>>>
    
    export type MarkFileAsReplacedMutationError = unknown

    export const useMarkFileAsReplaced = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFileAsReplaced>>, TError,{params: MarkFileAsReplacedParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markFileAsReplaced>>,
        TError,
        {params: MarkFileAsReplacedParams},
        TContext
      > => {

      const mutationOptions = getMarkFileAsReplacedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const serveFile1 = (
    path: string,
    filename: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/files/${path}/${filename}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getServeFile1InfiniteQueryKey = (path?: string,
    filename?: string,) => {
    return [
    'infinite', `/api/files/${path}/${filename}`
    ] as const;
    }

export const getServeFile1QueryKey = (path?: string,
    filename?: string,) => {
    return [
    `/api/files/${path}/${filename}`
    ] as const;
    }

    
export const getServeFile1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof serveFile1>>>, TError = unknown>(path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServeFile1InfiniteQueryKey(path,filename);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof serveFile1>>> = ({ signal }) => serveFile1(path,filename, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(path && filename), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ServeFile1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof serveFile1>>>
export type ServeFile1InfiniteQueryError = unknown


export function useServeFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof serveFile1>>>, TError = unknown>(
 path: string,
    filename: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveFile1>>,
          TError,
          Awaited<ReturnType<typeof serveFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useServeFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof serveFile1>>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveFile1>>,
          TError,
          Awaited<ReturnType<typeof serveFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useServeFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof serveFile1>>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useServeFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof serveFile1>>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getServeFile1InfiniteQueryOptions(path,filename,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getServeFile1QueryOptions = <TData = Awaited<ReturnType<typeof serveFile1>>, TError = unknown>(path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServeFile1QueryKey(path,filename);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof serveFile1>>> = ({ signal }) => serveFile1(path,filename, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(path && filename), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ServeFile1QueryResult = NonNullable<Awaited<ReturnType<typeof serveFile1>>>
export type ServeFile1QueryError = unknown


export function useServeFile1<TData = Awaited<ReturnType<typeof serveFile1>>, TError = unknown>(
 path: string,
    filename: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveFile1>>,
          TError,
          Awaited<ReturnType<typeof serveFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useServeFile1<TData = Awaited<ReturnType<typeof serveFile1>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveFile1>>,
          TError,
          Awaited<ReturnType<typeof serveFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useServeFile1<TData = Awaited<ReturnType<typeof serveFile1>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useServeFile1<TData = Awaited<ReturnType<typeof serveFile1>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getServeFile1QueryOptions(path,filename,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const previewFile1 = (
    path: string,
    filename: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/files/preview/${path}/${filename}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getPreviewFile1InfiniteQueryKey = (path?: string,
    filename?: string,) => {
    return [
    'infinite', `/api/files/preview/${path}/${filename}`
    ] as const;
    }

export const getPreviewFile1QueryKey = (path?: string,
    filename?: string,) => {
    return [
    `/api/files/preview/${path}/${filename}`
    ] as const;
    }

    
export const getPreviewFile1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof previewFile1>>>, TError = unknown>(path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewFile1InfiniteQueryKey(path,filename);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewFile1>>> = ({ signal }) => previewFile1(path,filename, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(path && filename), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PreviewFile1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof previewFile1>>>
export type PreviewFile1InfiniteQueryError = unknown


export function usePreviewFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewFile1>>>, TError = unknown>(
 path: string,
    filename: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFile1>>,
          TError,
          Awaited<ReturnType<typeof previewFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewFile1>>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFile1>>,
          TError,
          Awaited<ReturnType<typeof previewFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewFile1>>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePreviewFile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewFile1>>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPreviewFile1InfiniteQueryOptions(path,filename,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPreviewFile1QueryOptions = <TData = Awaited<ReturnType<typeof previewFile1>>, TError = unknown>(path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewFile1QueryKey(path,filename);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewFile1>>> = ({ signal }) => previewFile1(path,filename, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(path && filename), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PreviewFile1QueryResult = NonNullable<Awaited<ReturnType<typeof previewFile1>>>
export type PreviewFile1QueryError = unknown


export function usePreviewFile1<TData = Awaited<ReturnType<typeof previewFile1>>, TError = unknown>(
 path: string,
    filename: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFile1>>,
          TError,
          Awaited<ReturnType<typeof previewFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewFile1<TData = Awaited<ReturnType<typeof previewFile1>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewFile1>>,
          TError,
          Awaited<ReturnType<typeof previewFile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewFile1<TData = Awaited<ReturnType<typeof previewFile1>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePreviewFile1<TData = Awaited<ReturnType<typeof previewFile1>>, TError = unknown>(
 path: string,
    filename: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewFile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPreviewFile1QueryOptions(path,filename,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const previewByFileId1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/files/preview/documents/${id}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getPreviewByFileId1InfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/files/preview/documents/${id}`
    ] as const;
    }

export const getPreviewByFileId1QueryKey = (id?: string,) => {
    return [
    `/api/files/preview/documents/${id}`
    ] as const;
    }

    
export const getPreviewByFileId1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof previewByFileId1>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewByFileId1InfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewByFileId1>>> = ({ signal }) => previewByFileId1(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PreviewByFileId1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof previewByFileId1>>>
export type PreviewByFileId1InfiniteQueryError = unknown


export function usePreviewByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewByFileId1>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewByFileId1>>,
          TError,
          Awaited<ReturnType<typeof previewByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewByFileId1>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewByFileId1>>,
          TError,
          Awaited<ReturnType<typeof previewByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewByFileId1>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePreviewByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof previewByFileId1>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPreviewByFileId1InfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPreviewByFileId1QueryOptions = <TData = Awaited<ReturnType<typeof previewByFileId1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewByFileId1QueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewByFileId1>>> = ({ signal }) => previewByFileId1(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PreviewByFileId1QueryResult = NonNullable<Awaited<ReturnType<typeof previewByFileId1>>>
export type PreviewByFileId1QueryError = unknown


export function usePreviewByFileId1<TData = Awaited<ReturnType<typeof previewByFileId1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewByFileId1>>,
          TError,
          Awaited<ReturnType<typeof previewByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewByFileId1<TData = Awaited<ReturnType<typeof previewByFileId1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewByFileId1>>,
          TError,
          Awaited<ReturnType<typeof previewByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePreviewByFileId1<TData = Awaited<ReturnType<typeof previewByFileId1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePreviewByFileId1<TData = Awaited<ReturnType<typeof previewByFileId1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPreviewByFileId1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMetaAll1 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/files/meta`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMetaAll1InfiniteQueryKey = () => {
    return [
    'infinite', `/api/files/meta`
    ] as const;
    }

export const getGetMetaAll1QueryKey = () => {
    return [
    `/api/files/meta`
    ] as const;
    }

    
export const getGetMetaAll1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll1>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaAll1InfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaAll1>>> = ({ signal }) => getMetaAll1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMetaAll1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaAll1>>>
export type GetMetaAll1InfiniteQueryError = unknown


export function useGetMetaAll1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll1>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll1>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAll1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll1>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAll1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMetaAll1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMetaAll1InfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMetaAll1QueryOptions = <TData = Awaited<ReturnType<typeof getMetaAll1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaAll1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaAll1>>> = ({ signal }) => getMetaAll1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMetaAll1QueryResult = NonNullable<Awaited<ReturnType<typeof getMetaAll1>>>
export type GetMetaAll1QueryError = unknown


export function useGetMetaAll1<TData = Awaited<ReturnType<typeof getMetaAll1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll1>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAll1<TData = Awaited<ReturnType<typeof getMetaAll1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll1>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAll1<TData = Awaited<ReturnType<typeof getMetaAll1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMetaAll1<TData = Awaited<ReturnType<typeof getMetaAll1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMetaAll1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const findByDomainAndDomainId = (
    domain: string,
    domainId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/files/meta/${domain}/${domainId}`, method: 'GET', signal
    },
      options);
    }
  



export const getFindByDomainAndDomainIdInfiniteQueryKey = (domain?: string,
    domainId?: string,) => {
    return [
    'infinite', `/api/files/meta/${domain}/${domainId}`
    ] as const;
    }

export const getFindByDomainAndDomainIdQueryKey = (domain?: string,
    domainId?: string,) => {
    return [
    `/api/files/meta/${domain}/${domainId}`
    ] as const;
    }

    
export const getFindByDomainAndDomainIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof findByDomainAndDomainId>>>, TError = unknown>(domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindByDomainAndDomainIdInfiniteQueryKey(domain,domainId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findByDomainAndDomainId>>> = ({ signal }) => findByDomainAndDomainId(domain,domainId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && domainId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindByDomainAndDomainIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof findByDomainAndDomainId>>>
export type FindByDomainAndDomainIdInfiniteQueryError = unknown


export function useFindByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindByDomainAndDomainIdInfiniteQueryOptions(domain,domainId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getFindByDomainAndDomainIdQueryOptions = <TData = Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError = unknown>(domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindByDomainAndDomainIdQueryKey(domain,domainId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findByDomainAndDomainId>>> = ({ signal }) => findByDomainAndDomainId(domain,domainId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && domainId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindByDomainAndDomainIdQueryResult = NonNullable<Awaited<ReturnType<typeof findByDomainAndDomainId>>>
export type FindByDomainAndDomainIdQueryError = unknown


export function useFindByDomainAndDomainId<TData = Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindByDomainAndDomainId<TData = Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindByDomainAndDomainId<TData = Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindByDomainAndDomainId<TData = Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindByDomainAndDomainIdQueryOptions(domain,domainId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const findReplacedByDomainAndDomainId = (
    domain: string,
    domainId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/files/meta/${domain}/${domainId}/replaced`, method: 'GET', signal
    },
      options);
    }
  



export const getFindReplacedByDomainAndDomainIdInfiniteQueryKey = (domain?: string,
    domainId?: string,) => {
    return [
    'infinite', `/api/files/meta/${domain}/${domainId}/replaced`
    ] as const;
    }

export const getFindReplacedByDomainAndDomainIdQueryKey = (domain?: string,
    domainId?: string,) => {
    return [
    `/api/files/meta/${domain}/${domainId}/replaced`
    ] as const;
    }

    
export const getFindReplacedByDomainAndDomainIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>, TError = unknown>(domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindReplacedByDomainAndDomainIdInfiniteQueryKey(domain,domainId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>> = ({ signal }) => findReplacedByDomainAndDomainId(domain,domainId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && domainId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindReplacedByDomainAndDomainIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>
export type FindReplacedByDomainAndDomainIdInfiniteQueryError = unknown


export function useFindReplacedByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindReplacedByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindReplacedByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindReplacedByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindReplacedByDomainAndDomainIdInfiniteQueryOptions(domain,domainId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getFindReplacedByDomainAndDomainIdQueryOptions = <TData = Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError = unknown>(domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindReplacedByDomainAndDomainIdQueryKey(domain,domainId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>> = ({ signal }) => findReplacedByDomainAndDomainId(domain,domainId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && domainId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindReplacedByDomainAndDomainIdQueryResult = NonNullable<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>>
export type FindReplacedByDomainAndDomainIdQueryError = unknown


export function useFindReplacedByDomainAndDomainId<TData = Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindReplacedByDomainAndDomainId<TData = Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindReplacedByDomainAndDomainId<TData = Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindReplacedByDomainAndDomainId<TData = Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findReplacedByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindReplacedByDomainAndDomainIdQueryOptions(domain,domainId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const findActiveByDomainAndDomainId = (
    domain: string,
    domainId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/files/meta/${domain}/${domainId}/active`, method: 'GET', signal
    },
      options);
    }
  



export const getFindActiveByDomainAndDomainIdInfiniteQueryKey = (domain?: string,
    domainId?: string,) => {
    return [
    'infinite', `/api/files/meta/${domain}/${domainId}/active`
    ] as const;
    }

export const getFindActiveByDomainAndDomainIdQueryKey = (domain?: string,
    domainId?: string,) => {
    return [
    `/api/files/meta/${domain}/${domainId}/active`
    ] as const;
    }

    
export const getFindActiveByDomainAndDomainIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>, TError = unknown>(domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindActiveByDomainAndDomainIdInfiniteQueryKey(domain,domainId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>> = ({ signal }) => findActiveByDomainAndDomainId(domain,domainId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && domainId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindActiveByDomainAndDomainIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>
export type FindActiveByDomainAndDomainIdInfiniteQueryError = unknown


export function useFindActiveByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindActiveByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindActiveByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindActiveByDomainAndDomainIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindActiveByDomainAndDomainIdInfiniteQueryOptions(domain,domainId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getFindActiveByDomainAndDomainIdQueryOptions = <TData = Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError = unknown>(domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindActiveByDomainAndDomainIdQueryKey(domain,domainId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>> = ({ signal }) => findActiveByDomainAndDomainId(domain,domainId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && domainId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindActiveByDomainAndDomainIdQueryResult = NonNullable<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>>
export type FindActiveByDomainAndDomainIdQueryError = unknown


export function useFindActiveByDomainAndDomainId<TData = Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindActiveByDomainAndDomainId<TData = Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>,
          TError,
          Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindActiveByDomainAndDomainId<TData = Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindActiveByDomainAndDomainId<TData = Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError = unknown>(
 domain: string,
    domainId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findActiveByDomainAndDomainId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindActiveByDomainAndDomainIdQueryOptions(domain,domainId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMeta2 = (
    category: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/files/meta/${category}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMeta2InfiniteQueryKey = (category?: string,) => {
    return [
    'infinite', `/api/files/meta/${category}`
    ] as const;
    }

export const getGetMeta2QueryKey = (category?: string,) => {
    return [
    `/api/files/meta/${category}`
    ] as const;
    }

    
export const getGetMeta2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMeta2>>>, TError = unknown>(category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeta2InfiniteQueryKey(category);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeta2>>> = ({ signal }) => getMeta2(category, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(category), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMeta2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMeta2>>>
export type GetMeta2InfiniteQueryError = unknown


export function useGetMeta2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta2>>>, TError = unknown>(
 category: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta2>>,
          TError,
          Awaited<ReturnType<typeof getMeta2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeta2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta2>>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta2>>,
          TError,
          Awaited<ReturnType<typeof getMeta2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeta2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta2>>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMeta2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta2>>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMeta2InfiniteQueryOptions(category,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMeta2QueryOptions = <TData = Awaited<ReturnType<typeof getMeta2>>, TError = unknown>(category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeta2QueryKey(category);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeta2>>> = ({ signal }) => getMeta2(category, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(category), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMeta2QueryResult = NonNullable<Awaited<ReturnType<typeof getMeta2>>>
export type GetMeta2QueryError = unknown


export function useGetMeta2<TData = Awaited<ReturnType<typeof getMeta2>>, TError = unknown>(
 category: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta2>>,
          TError,
          Awaited<ReturnType<typeof getMeta2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeta2<TData = Awaited<ReturnType<typeof getMeta2>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta2>>,
          TError,
          Awaited<ReturnType<typeof getMeta2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeta2<TData = Awaited<ReturnType<typeof getMeta2>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMeta2<TData = Awaited<ReturnType<typeof getMeta2>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMeta2QueryOptions(category,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const downloadByFileId1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/files/download/documents/${id}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getDownloadByFileId1InfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/files/download/documents/${id}`
    ] as const;
    }

export const getDownloadByFileId1QueryKey = (id?: string,) => {
    return [
    `/api/files/download/documents/${id}`
    ] as const;
    }

    
export const getDownloadByFileId1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadByFileId1>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadByFileId1InfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadByFileId1>>> = ({ signal }) => downloadByFileId1(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadByFileId1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadByFileId1>>>
export type DownloadByFileId1InfiniteQueryError = unknown


export function useDownloadByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadByFileId1>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadByFileId1>>,
          TError,
          Awaited<ReturnType<typeof downloadByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadByFileId1>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadByFileId1>>,
          TError,
          Awaited<ReturnType<typeof downloadByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadByFileId1>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDownloadByFileId1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadByFileId1>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadByFileId1InfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDownloadByFileId1QueryOptions = <TData = Awaited<ReturnType<typeof downloadByFileId1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadByFileId1QueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadByFileId1>>> = ({ signal }) => downloadByFileId1(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadByFileId1QueryResult = NonNullable<Awaited<ReturnType<typeof downloadByFileId1>>>
export type DownloadByFileId1QueryError = unknown


export function useDownloadByFileId1<TData = Awaited<ReturnType<typeof downloadByFileId1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadByFileId1>>,
          TError,
          Awaited<ReturnType<typeof downloadByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadByFileId1<TData = Awaited<ReturnType<typeof downloadByFileId1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadByFileId1>>,
          TError,
          Awaited<ReturnType<typeof downloadByFileId1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadByFileId1<TData = Awaited<ReturnType<typeof downloadByFileId1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDownloadByFileId1<TData = Awaited<ReturnType<typeof downloadByFileId1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadByFileId1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadByFileId1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDocumentById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto>(
      {url: `/api/files/documents/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDocumentByIdInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/files/documents/${id}`
    ] as const;
    }

export const getGetDocumentByIdQueryKey = (id?: string,) => {
    return [
    `/api/files/documents/${id}`
    ] as const;
    }

    
export const getGetDocumentByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocumentById>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentByIdInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentById>>> = ({ signal }) => getDocumentById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentById>>>
export type GetDocumentByIdInfiniteQueryError = unknown


export function useGetDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentById>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDocumentByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentById>>> = ({ signal }) => getDocumentById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentById>>>
export type GetDocumentByIdQueryError = unknown


export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteFile = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ResponseDataString>(
      {url: `/api/files/documents/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteFile(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFile>>>
    
    export type DeleteFileMutationError = unknown

    export const useDeleteFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFile>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    